"use client";

// src/QueryErrorResetBoundary.tsx
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from "react";
import { jsx } from "react/jsx-runtime";
function createValue() {
  var _isReset = false;
  return {
    clearReset: function clearReset() {
      _isReset = false;
    },
    reset: function reset() {
      _isReset = true;
    },
    isReset: function isReset() {
      return _isReset;
    }
  };
}
var QueryErrorResetBoundaryContext = React.createContext(createValue());
var useQueryErrorResetBoundary = function useQueryErrorResetBoundary() {
  return React.useContext(QueryErrorResetBoundaryContext);
};
var QueryErrorResetBoundary = function QueryErrorResetBoundary(_ref) {
  var children = _ref.children;
  var _React$useState = React.useState(function () {
      return createValue();
    }),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    value = _React$useState2[0];
  return /* @__PURE__ */jsx(QueryErrorResetBoundaryContext.Provider, {
    value: value,
    children: typeof children === "function" ? children(value) : children
  });
};
export { QueryErrorResetBoundary, useQueryErrorResetBoundary };